const STORAGE_KEY = "investx_web_auth_unlock";
const WEB_AUTH_PIN = "147258";

export function isWebAuthEnabled() {
  if (process.env.REACT_APP_ENABLE_WEB_AUTH === "true") {
    return true;
  }
  if (typeof window !== "undefined") {
    return sessionStorage.getItem(STORAGE_KEY) === "1";
  }
  return false;
}

export function unlockWebAuth() {
  sessionStorage.setItem(STORAGE_KEY, "1");
}

export function validateWebAuthPin(pin) {
  return pin === WEB_AUTH_PIN;
}

export function tryUnlockFromSearch(search) {
  const params = new URLSearchParams(search);
  const key = params.get("webauth");
  const expected = process.env.REACT_APP_WEB_AUTH_KEY || "investx-dev";
  if (key && key === expected) {
    unlockWebAuth();
    return true;
  }
  return false;
}

export function getSignInRedirectPath() {
  return isWebAuthEnabled() ? "/login" : "/";
}
